export enum CatalogProductType {
  ELECTRICAL_CABINET = 'electrical_cabinet',
  SPINE_MODULE = 'spine_module',
  RUUVI_TAG = 'ruuvi_tag',
  HEATER = 'heater',
  GENERATOR = 'generator',
  AURORA = 'aurora'
}
